var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:['p_form_checkbox', _vm.giveMeClassReadOnly]},[_c('span',{class:_vm.lclass,attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"id":_vm.id,"type":"checkbox","disabled":_vm.readOnly},domProps:{"checked":_vm.isChecked},on:{"change":_vm.change}}),_c('span',{staticClass:"p_form_check"})])
}
var staticRenderFns = []

export { render, staticRenderFns }